import 'select2';
import Modal from "../modal/modal";
import getPricesInfo from "../price";
import _each from 'lodash/each';
import dependencies from "./dependencies";
import tocbot from "../toc";
import $ from "jquery";

let skipProductOptionEvent = false,
    skipProductOptionPriceCall = false;

function appendSelectedOption(id, group, name, number, price, price_delta, clear, templateSelector) {
    let template = document.querySelector(templateSelector ?? 'script[data-template="product-options-selected"]').innerText;
    $.each({id: id, name: name, number: number, price: price, delta_price: price_delta}, function (key, value) {
        template = template.replace(new RegExp(':' + key, 'g'), value === null ? '' : value);
    });
    if (clear === true) {
        resetSelectedOption(group);
    }
    $('#group-selected-' + group).append(template);
}

function resetSelectedOption(group) {
    $('#group-selected-' + group).html('');
}

function handleProductOptions(container, modal) {
    let fieldName, fieldValue, group;

    skipProductOptionEvent = true;

    if (container.length > 0) {
        // find select
        let select = $('select', container);
        if (select.length > 0) {
            select.each(function () {
                group = $(this).data('group');
                if (modal === true) {
                    fieldName = $(this).attr('name').replace('modal-', '');
                } else {
                    fieldName = 'modal-' + $(this).attr('name');
                }
                $('select[name="' + fieldName + '"]').val($(this).val()).trigger('change');

                let data = $('option:selected', $(this)).text().split(' | ');
                appendSelectedOption('product-option-mobile-' + $(this).val(), group, data[0], data[1], data[2], data[2], true);
            });
        }

        // find checked radios or checkboxes
        let inputs = $('input', container), reset = false;
        if (inputs.length > 0) {
            inputs.each(function () {
                if (modal === true) {
                    fieldName = $(this).attr('name').replace('modal-', '');
                } else {
                    fieldName = 'modal-' + $(this).attr('name');
                }
                fieldValue = $(this).val(), group = $(this).data('group');
                if (!reset) {
                    // reset checked inputs
                    $('input[name="' + fieldName + '"]').prop('checked', false)
                    // reset selected options
                    resetSelectedOption(group);
                    reset = true;
                }

                if ($(this).is('[type="text"]')) {
                    $('input[name="' + fieldName + '"]').val(fieldValue);

                    let parent = modal ? $(this).closest('.row') : $(this).closest('tr');
                    appendSelectedOption(parent.attr('id'), group, fieldValue, null, null, null, false, 'script[data-template="product-options-selected-text"]');
                }

                if ($(this).is(':checked')) {
                    $('input[name="' + fieldName + '"]').filter(function () {
                        return $(this).val() === fieldValue;
                    }).prop('checked', true).trigger('change');

                    let parent = modal ? $(this).closest('.row') : $(this).closest('tr');
                    appendSelectedOption(parent.attr('id'), group, parent.find('.option-name').text(), parent.find('.option-material-number').text(), parent.find('.option-price').text(), parent.find('.option-price-delta').text());
                }
            });
        }
    }

    skipProductOptionEvent = false;
}

function handleOptionUpdate(form) {
    let productOptions = {},
        action = form.action;
    $('[name^="option-group"]', $(form)).each(function (index) {
        let group = $(this).data('group'), option = $(this).data('option');
        if (!group || ($(this).is('[type="text"]') && $(this).val().trim() === '')) {
            return true;
        }
        if (!$(this).is(':disabled') && ($(this).is('[type="text"]') || $(this).is('select') || $(this).is(':checked'))) {
            productOptions[group] = {
                ...productOptions[group],
                [option || $(this).val()]: $(this).val()
            };
        }
    });

    window.axios.post(action, {'option-groups': productOptions})
        .then(({data}) => {
            //
        })
        .finally(() => {
            // reload cart
            location.reload();
        });
}

function initProductSelect() {
    $('select.product-option-items').select2({
        theme: 'bootstrap-5',
        minimumResultsForSearch: 10,
        dropdownCssClass: 'product-option-selection',
        selectionCssClass: 'product-option-selection',
        escapeMarkup: function (m) {
            return m;
        },
        templateSelection: productSelectTemplate,
        templateResult: productSelectTemplate,
    });
}

function productSelectTemplate(option) {
    if (!option.id) {
        return option.text;
    }

    let data = option.text.trim().split(' | ');
    return '<span class="option-name">' + (data[0] || '') + '</span>'
        + '<span class="option-material-number">' + (data[1] || '') + '</span>'
        + '<span class="option-price-delta">' + (data[2] || '') + '</span>';
}

$(document).ready(() => {
    initProductSelect();
}).resize(() => {
    initProductSelect();
});

$(document).on('click', '.apply-product-options', function (event) {
    handleProductOptions($(this).closest('.modal-content'), true);
}).on('change', '.product-option-items:not([type="text"])', function (event) {
    if (!skipProductOptionEvent) {
        handleProductOptions($(this).closest('table'), false);

        const priceProducts = document.querySelectorAll('.price-async[data-product-id]');
        if (priceProducts.length > 0) {
            getPricesInfo(priceProducts);
        }
    }
}).on('blur', '.product-option-items[type="text"]', function () {
    if (!skipProductOptionEvent) {
        handleProductOptions($(this).closest('table'), false);
    }
}).on('click', '.cart-load-options', function (event) {
    event.preventDefault();
    let _this = $(this);
    const spinner = _this.next('i.loading-spinner');

    if (spinner.length > 0) {
        spinner.toggleClass('d-none', false);
        _this.toggleClass('d-none', true);
    }

    window.axios.get(_this.attr('href'))
        .then(({data}) => {

            let modal = new Modal({
                title: _this.attr('title'), content: data, size: _this.data('size') || 'xl', buttons: Modal.buttons.submit,
            }).show();

            modal.on('shown', function (modal, event) {
                getPricesInfo(_this);

                $(document).on('change', $('.product-option-items:not([type="text"])', modal.el), function (event) {
                    getPricesInfo(_this);
                });
            }).on('hide', function (modal, event) {
                $('.product-option-items', modal.el).unbind('change');
            }).once('submit', function (modal, ev, button) {
                if (button && button.value) {
                    handleOptionUpdate(modal.el.querySelector('form'))
                }
            });
        })
        .finally(() => {
            if (spinner.length > 0) {
                spinner.toggleClass('d-none', true);
                _this.toggleClass('d-none', false);
            }
        });
}).on('price-call-finished', function (event, response) {
    if (skipProductOptionPriceCall) {
        skipProductOptionPriceCall = false
    } else {
        skipProductOptionEvent = true;
        _each(response?.prices ?? [], (price, index) => {
            dependencies.handle(index, price?.option_dependencies ?? []);
        });
        skipProductOptionPriceCall = true;
        const priceProducts = document.querySelectorAll('.price-async[data-product-id]');
        if (priceProducts.length > 0) {
            getPricesInfo(priceProducts);
        }
        skipProductOptionEvent = false;
    }
    initProductSelect();
}).on('click', 'table.table-clickable td', function (event) {
    if ($(event.target).is('input')) {
        return;
    }

    let element = $(this).closest('tr').find('input:not(:disabled)'),
        status = !element.is(':checked');
    if (element.is(':radio')) {
        status = true;
    }
    element.prop('checked', status).trigger('change');
}).on('show.bs.modal', '.modal.group-edit', function () {
    initProductSelect();
});

// *** TOC ***
const toc = document.querySelector('.js-toc-content');
if (toc) {
    tocbot.initToc();
    tocbot.checkPosition($('.sticky-product-information'), $('.js-toc'))
}

// *** Sticky Header ***
let stickyElement = $('.sticky-product-information');
if (stickyElement.length > 0) {
    let stickyTop = stickyElement.offset().top;
    $(window).scroll(function () {
        let stickyHeaderHeight = $('.is-main-navigation-bar.sticky.is-pinned').height() || 0,
            windowTop = $(window).scrollTop() + stickyHeaderHeight,
            tocConfig = {
                headingsOffset: stickyHeaderHeight + stickyElement.height() + 15,
                onClick: function (e) {
                },
            };

        if (windowTop < stickyTop) {
            stickyElement.removeClass('sticky-product-information-fixed');
            $('.sticky-product-information-fixed-extended').css('top', '');
        } else if (windowTop >= stickyTop) {
            stickyElement.addClass('sticky-product-information-fixed');
            $('.sticky-product-information-fixed-extended').css('top', (stickyHeaderHeight - 1) + 'px');
            tocConfig = {
                headingsOffset: stickyHeaderHeight + stickyElement.height() + 15,
                onClick: function (event) {
                    event.preventDefault();
                    event.stopPropagation();
                    if (!$(this).hasClass('is-active-link')) {
                        let offset = stickyHeaderHeight + stickyElement.height() + 20;
                        $('html, body').animate({
                            scrollTop: $($(this).attr('href')).offset().top - offset
                        }, 420);
                    }
                },
            };
        }
        tocbot.initToc(tocConfig, true);
        tocbot.checkPosition(stickyElement, $('.js-toc'));
    });
}
